(function () {
  function initMedia(root) {
    if (root.dataset.rsaiInited === "1") return;
    root.dataset.rsaiInited = "1";

    const track = root.querySelector("[data-rsai-card-track]");
    const prev = root.querySelector("[data-rsai-prev]");
    const next = root.querySelector("[data-rsai-next]");
    if (!track) return;

    function updateArrows() {
      const slide = track.querySelector("[data-rsai-card-slide]");
      if (!slide) return;

      const w = slide.getBoundingClientRect().width || 1;
      const maxIdx = Math.max(
        0,
        track.querySelectorAll("[data-rsai-card-slide]").length - 1
      );
      const idx = Math.round(track.scrollLeft / w);

      if (prev) prev.classList.toggle("is-hidden", idx <= 0);
      if (next) next.classList.toggle("is-hidden", idx >= maxIdx);
    }

    track.addEventListener(
      "scroll",
      () => requestAnimationFrame(updateArrows),
      { passive: true }
    );

    updateArrows();

    const card =
      root.closest(".card-wrapper") ||
      root.closest(".card") ||
      root.parentElement;
    const productLink = card
      ? card.querySelector('a.full-unstyled-link[href]')
      : null;

    function stopAll(e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }

    function slideTo(dir) {
      const slide = track.querySelector("[data-rsai-card-slide]");
      if (!slide) return;
      const w = slide.getBoundingClientRect().width || 1;

      const idx = Math.round(track.scrollLeft / w);
      const nextIdx = Math.max(0, idx + dir);
      track.scrollTo({ left: nextIdx * w, behavior: "smooth" });

      setTimeout(updateArrows, 220);
    }

    if (prev) {
      prev.addEventListener("pointerdown", stopAll, true);
      prev.addEventListener(
        "click",
        function (e) {
          stopAll(e);
          slideTo(-1);
        },
        true
      );
    }

    if (next) {
      next.addEventListener("pointerdown", stopAll, true);
      next.addEventListener(
        "click",
        function (e) {
          stopAll(e);
          slideTo(1);
        },
        true
      );
    }

    root.addEventListener("click", function (e) {
      if (e.target.closest("[data-rsai-prev], [data-rsai-next]")) return;
      if (!productLink || !productLink.href) return;
      window.location.href = productLink.href;
    });
  }

  function boot() {
    document
      .querySelectorAll("#ProductGridContainer [data-rsai-card-media]")
      .forEach(initMedia);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

/* === RSAI: product recommendations mobile slider indicator (isolated patch) === */
(function () {
  function ensureRecDotsStyles() {
    if (document.getElementById("rsai-rec-dots-style")) return;

    const style = document.createElement("style");
    style.id = "rsai-rec-dots-style";
    style.textContent = `
@media (max-width: 749px) {
  #ProductRecommendations [data-rsai-prev],
  #ProductRecommendations [data-rsai-next],
  product-recommendations [data-rsai-prev],
  product-recommendations [data-rsai-next] {
    display: none !important;
  }

  #ProductRecommendations [data-rsai-card-media],
  product-recommendations [data-rsai-card-media] {
    position: relative;
  }

  #ProductRecommendations .rsai-rec-bar,
  product-recommendations .rsai-rec-bar {
    position: absolute;
    left: 10px;
    bottom: 10px;
    width: 30px;
    height: 2px;
    border-radius: 999px;
    background: rgba(0, 0, 0, 0.18);
    overflow: hidden;
    pointer-events: none;
    z-index: 3;
  }

  #ProductRecommendations .rsai-rec-bar i,
  product-recommendations .rsai-rec-bar i {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    background: rgba(0, 0, 0, 0.85);
    border-radius: 999px;
    transform: translateX(0px);
    transition: transform 120ms linear;
  }
}
`;
    document.head.appendChild(style);
  }

  function initRecMedia(root) {
    if (root.dataset.rsaiRecInited === "1") return;
    root.dataset.rsaiRecInited = "1";

    const track = root.querySelector("[data-rsai-card-track]");
    const prev = root.querySelector("[data-rsai-prev]");
    const next = root.querySelector("[data-rsai-next]");
    if (!track) return;

    ensureRecDotsStyles();

    const isMobile =
      window.matchMedia && window.matchMedia("(max-width: 749px)").matches;

    let bar = null;
    let barFill = null;

    function ensureBar(slideCount) {
      if (!isMobile) return;
      if (slideCount <= 1) return;
      if (bar) return;

      bar = document.createElement("div");
      bar.className = "rsai-rec-bar";

      barFill = document.createElement("i");
      bar.appendChild(barFill);
      root.appendChild(bar);

      const bw = bar.getBoundingClientRect().width || 1;
      const tw = Math.max(6, Math.min(12, bw / slideCount));
      barFill.style.width = tw + "px";
      barFill.style.transform = "translateX(0px)";
    }

    function updateBar(idx, maxIdx) {
      if (!bar || !barFill) return;

      if (maxIdx <= 0) {
        barFill.style.transform = "translateX(0px)";
        return;
      }

      const bw = bar.getBoundingClientRect().width || 1;
      const tw = barFill.getBoundingClientRect().width || 0;
      const travel = Math.max(0, bw - tw);
      const x = (idx / maxIdx) * travel;

      barFill.style.transform = "translateX(" + x + "px)";
    }

    function updateState() {
      const slides = track.querySelectorAll("[data-rsai-card-slide]");
      if (!slides.length) return;

      const maxIdx = slides.length - 1;
      const pos = track.scrollLeft || 0;

      let idx = 0;
      let best = Infinity;
      for (let i = 0; i < slides.length; i++) {
        const d = Math.abs(slides[i].offsetLeft - pos);
        if (d < best) {
          best = d;
          idx = i;
        }
      }

      if (prev) prev.classList.toggle("is-hidden", idx <= 0);
      if (next) next.classList.toggle("is-hidden", idx >= maxIdx);

      ensureBar(slides.length);
      updateBar(idx, maxIdx);
    }

    track.addEventListener(
      "scroll",
      () => requestAnimationFrame(updateState),
      { passive: true }
    );

    if (prev) prev.addEventListener("click", () => setTimeout(updateState, 0), true);
    if (next) next.addEventListener("click", () => setTimeout(updateState, 0), true);

    updateState();

    const card =
      root.closest(".card-wrapper") ||
      root.closest(".card") ||
      root.parentElement;

    const productLink = card
      ? card.querySelector('a.full-unstyled-link[href]')
      : null;

    if (productLink && productLink.href) {
      root.addEventListener("click", function (e) {
        if (e.target.closest("[data-rsai-prev], [data-rsai-next]")) return;
        if (e.target.closest("a[href]")) return;
        window.location.href = productLink.href;
      });
    }
  }

  function getRecContainer() {
    return (
      document.querySelector("#ProductRecommendations") ||
      document.querySelector("product-recommendations")
    );
  }

  function bootRecommendations() {
    const c = getRecContainer();
    if (!c) return;
    c.querySelectorAll("[data-rsai-card-media]").forEach(initRecMedia);
  }

  bootRecommendations();

  const obs = new MutationObserver(bootRecommendations);
  obs.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener("shopify:section:load", bootRecommendations);
})();